export type EScriptVersion = typeof wellWorldVersion | typeof eScript20230411Version
export type EScriptAutoShipInterval = (typeof eScriptAutoShipIntervals)[number]

export const wellWorldVersion = 'well_world' as const
export const eScript20230411Version = '2023-04-11' as const

export const eScriptAutoShipIntervals = ['1m', '2m', '3m'] as const
